import { apiPlataforma } from "../repositories/api.plataforma";

export interface PermissaoAuditoriaAdministrativa {
  permitido: boolean;
  permissao?: "ADM" | "ADMTENANT";
  municipio?: string | null;
}
export async function obterPermissaoAuditoria(): Promise<PermissaoAuditoriaAdministrativa> {
  try {
    const { data } = await apiPlataforma.get<PermissaoAuditoriaAdministrativa>("/auditoria/permissao");
    return data;
  } catch (error) {
    if (error.response?.status === 403) return { permitido: false };
    throw error;
  }
}
export function permiteAuditoriaAdministrativa(data?: PermissaoAuditoriaAdministrativa): boolean {
  return data?.permitido === true && (data.permissao === "ADM" || data.permissao === "ADMTENANT");
}
export const auditoriaAcessoKey = (tokens: { "x-tn-token"?: string; "x-auth-token"?: string }) => [
  "auditoria-administrativa-acesso",
  tokens["x-tn-token"],
  tokens["x-auth-token"],
];
